import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import {TabPanel} from "../../../components/tab-panel-comp";
import {useTranslation} from "react-i18next";


export const TabPayment = ({tabValue, distributor}) => {
    const {t} = useTranslation();

    return(
        <TabPanel value={tabValue} index={4} typePanel="distributor">
            <Box sx={{maxWidth: 800, mx: "auto"}}>
                <Typography variant="h6" gutterBottom sx={{display: "flex", alignItems: "center"}}>
                    <PaymentIcon sx={{mr: 1}}/> {t("PaymentMethods")}
                </Typography>

                {distributor.paymentMethods && distributor.paymentMethods.length > 0 ? (
                    <Grid container spacing={3}>
                        {distributor.paymentMethods.map((method, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card variant="outlined" sx={{height: "100%"}}>
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            {method}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {index === 0
                                                ? t("CreditCardDescription")
                                                : index === 1
                                                    ? t("BankTransferDescription")
                                                    : t("CashOnDeliveryDescription")}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography variant="body1">{t("NoPaymentInfoAvailable")}</Typography>
                )}

                <Box sx={{mt: 4}}>
                    <Typography variant="h6" gutterBottom>
                        {t("PaymentPolicy")}
                    </Typography>
                    <Typography variant="body1" paragraph>
                        {t("PaymentPolicyDescription")}
                    </Typography>
                </Box>
            </Box>
        </TabPanel>
    )
}